import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import dayjs from 'dayjs';

class Component extends BaseComponent {
    render({ date, base_url, trackEvent }) {
        const action = 'Click';
        const dates = this.returnDates();
        const labels = this.returnLabels();

        return (
            <div className='daily-links'>
                {labels.map((label, i) =>
                    <a
                        href={this.returnHref(base_url, dates, i)}
                        className={this.returnClass(date, dates, i)}
                        onClick={() => trackEvent([
                            action,
                            `Nav_Daily_Text:${label}`,
                        ])}
                    >
                        {label}
                    </a>
                )}
                {!base_url.match(/vip/) &&
                    <a
                        href='/readings-reports/subscription/vip-membership'
                        onClick={() => trackEvent([action, 'Nav_Daily_Text:VIP'])}
                    >
                        VIP {base_url.match(/horoscope/) ? 'Horoscopes' : 'Readings'}
                    </a>
                }
            </div>
        );
    }

    returnLabels = () => {
        if (this.props.base_url.match(/weekly/)) {
            return ['Last Week', 'This Week', 'Next Week'];
        } else if (this.props.base_url.match(/monthly/)) {
            return ['Last Month', 'This Month', 'Next Month'];
        }

        return ['Yesterday', 'Today', 'Tomorrow'];
    }

    returnDates = () => {
        if (this.props.base_url.match(/weekly/)) {
            return [
                dayjs().day(1).subtract(1, 'week').format('YYYY-MM-DD'),
                dayjs().day(1).format('YYYY-MM-DD'),
                dayjs().day(1).add(1, 'week').format('YYYY-MM-DD'),
            ];
        } else if (this.props.base_url.match(/monthly/)) {
            return [
                dayjs().date(1).subtract(1, 'month').format('YYYY-MM-DD'),
                dayjs().date(1).format('YYYY-MM-DD'),
                dayjs().date(1).add(1, 'month').format('YYYY-MM-DD'),
            ];
        }

        return [
            dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
            dayjs().format('YYYY-MM-DD'),
            dayjs().add(1, 'day').format('YYYY-MM-DD'),
        ];
    }

    returnHref = (base_url, dates, i) => {
        if (i == 0 && this.props.hide_prev || i == 2 && this.props.hide_next) {
            return null;
        }

        return `${base_url}/${dates[i]}`;
    }

    returnClass = (date, dates, i) => {
        if (i == 0 && this.props.hide_prev || i == 2 && this.props.hide_next) {
            return 'disabled';
        }

        if (date == dates[i]) {
            return 'selected';
        }

        return '';
    }
}

const mapStateToProps = (state) => ({
    hide_prev: state.hide_prev,
    hide_next: state.hide_next,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
